import { MyLavorazioneAccessoria } from "../document/quoting-model";

export class wizardFormEditoriaModel {
    numCopie: string = "";
    idCopie: string = "";
    tipoCopie: string = "";
    numFacciate: string = "";
    idFacciate: string = "";
    tipoFacciate: string = "";
    idFormati: string = "";
    idColori1: string = "";
    idCarte1: string = "";
    nomeCarte1: string = "";
    nomeCarte2: string = "";
    idGrammature1: string = "";
    nomeGrammature1: string = "";
    idPlastificazioni1: string = "";
    idCopertine: string = "";
    idColori2: string = "";
    idCarte2: string = "";
    idGrammature2: string = "";
    nomeGrammature2: string = "";
    idPlastificazioni2: string = "";
    idRilegature: string = "";
    taglio: boolean = false;
    sezione: string = "";
    tipoStampaInternoSoloFronte: boolean = false;
    stampa1_colori_fronte: string = "";
    stampa1_colori_retro: string = "";
    stampa2_colori_fronte: string = "";
    stampa2_colori_retro: string = "";
    lavorazioniAccessorie: Array<LavorazioniAccessorieModel>;
    wizardId: number = 0;
    customerdId: string;
    StrCustomerId: string;
    tipoStampaCopertinaSoloFronte: boolean = false;
    macrocategoryWizardId: number = 0;
    richiestaName: string = "";
    richiestaSubName: string = "";
    richiestaEmail: string = "";
    isRichiestaEmailValid: boolean = false;
    richiestaTelephone: string = "";
    richiestaSocieta: string = "";
    richiestaJobname: string = "";
    richiestaCondizioni: boolean = false;
    richiestaNote: string = "";
    idPiegature: string = "";
    soggettiMultipli: boolean = false;
    numSoggetti: string = "";
    baseFormato: string = "";
    altezzaFormato: string = "";
    idTagli: string = "";
    idBusta: string = "";
    idMaterialiFlessibili: string = "";
    idSupportiRigidi: string = "";
    idOcchielli: string = "";
    idAsole: string = "";
    idCuciture: string = "";
    idElettrosaldature: string = "";
    disposizione_occhielli_id: string = "";
    distanza_occhielli: string = "";
    diametro_asola: string = "";
    disposizione_asola_id: string = "";
    disposizione_cucitura_id: string = "";
    disposizione_elettrosaldatura_id: string = "";
    tipoBifacciale: string = "";
    idBiancoCoprente: string = "";
    language: string = "";
    currency: string = "";

    idPantoneFronte1: string = "";
    idPantoneFronte2: string = "";
    idPantoneRetro1: string = "";
    idPantoneRetro2: string = "";


    idCartoncino: string = "";
    nomeCartoncino: string = "";
    idGrammatureCartoncino: string = "";
    nomeGrammatureCartoncino: string = "";
    
    numDiametroInternoAnimaLabel: number = 0;
    numDiametroMassimoEsternoAnimaLabel: number = 0;
    numEtichette: string = "";
    idAvvolgimento: string = "";
    idFustella: string = "";
    idFormatoTipo: string = "";
    idTipoLavoroLabel: string = "";
    subSection: string = "";
    listaFormatiMultipli: Array<FormatiMultipliObj>;
    isFormatoMultiploEnabled:boolean=false;

}

export class FormatiMultipliObj {
    Id: number;
    Name: string;
    Width: number;
    Height: number;
    Copie: number;
    copieIsValid: boolean=true;
    copieMessage:string= "";;
    widthIsValid: boolean=true;;
    widthMessage:string= "";;
    heightIsValid: boolean=true;;
    heightMessage:string= "";;
}

export class MatrixModelCalculation
{
    lavorazioneVerticaleId: number;
    lavorazioneOrizzontaleId: number;
    quantita:number;
}

export class LavorazioniAccessorieModel {
    lavorazioneId: number;
    valoreLavorazione: string="";
    numWidthFormValue: string = "";
    numHeightFormValue: string = "";
    numDepthFormValue: string = "";
    tipo: number = 0;
    matrixValues:Array<MatrixModelCalculation>;
}

export class PriceEstimationModel {
    RowId: number;
    Currency: string = "€";
    UnitPrice: string = "0,00";
    Imponibile: string = "0,00";
    Iva: string = "0,00";
    Total: string = "0,00";
    TotalAmount: string = "0,00";
    WeightUm: string = "Kg";
    Weight: string = "0,00";
    TablePriceList: any;
    TableScontisticaPriceList: any;
    DataId: number;
    DayName: string = "";
    DayNumber: string = "";
    QuantityID: number;
    Quantity: number = 0;
    AltezzaDorso: Number = 0.00;
    Varianti: string;
    PrezzoOriginalestato: boolean;
    PrezzoOriginaleimporto: Number = 0.00;
    DayDescriptionStatus: boolean;
    DayDescriptionName: string = "";
}

export class FileCombinationModel {
    PathFile: string;
    NomeFile: string;
    PathIstruzioni: string;
    NomeIstruzioni: string;
}

export class wizardFormAdesiviModel {
    numCopie: any;
    numSoggetti: any;
    formati: any;
    base: any;
    altezza: any;
    plastificazioni1: any;
    materialiFlessibili: any;
    supportiRigidi: any;
    lavorazioniAccessorie: any;
}


export class wizardFormBandieraModel {
    numCopie: any;
    numSoggetti: any;
    formati: any;
    base: any;
    altezza: any;
    materialiFlessibili: any;
    occhielli: any;
    distanceOcchielli: any;
    disposizioneOcchielli: any;
    asole: any;
    diametroAsola: any;
    disposizioneAsole: any;
    cuciture: any;
    disposizioneCucitura: any;
    lavorazioniAccessorie: any;
}

export class wizardFormBannerModel {
    numCopie: any;
    numSoggetti: any;
    formati: any;
    base: any;
    altezza: any;
    materialiFlessibili: any;
    occhielli: any;
    distanceOcchielli: any;
    disposizioneOcchielli: any;
    asole: any;
    diametroAsola: any;
    disposizioneAsole: any;
    elettrosaldature: any;
    disposizioneElettrosaldature: any;
    lavorazioniAccessorie: any;
}

export class wizardFormBusteModel {
    numCopie: any;
    numSoggetti: any;
    categorieCarte: any;
    tipologieBusta: any;
    colori1: any;
    fronte: any = "";
    colori2: any;
    lavorazioniAccessorie: any;
}

export class wizardFormCommercialeModel {
    numCopie: any;
    numSoggetti: any;
    categorieCarte: any;
    formati: any;
    base: any;
    altezza: any;
    carte1: any;
    grammature1: any;
    colori1: any;
    colori2: any;
    plastificazioni1: any;
    piegature: any;
    rifilo: any;
    lavorazioniAccessorie: any;
}

export class wizarFormEtichetteModel {
    numCopie: any;
    numSoggetti: any;
    categorieCarte: any;
    formati: any;
    base: any;
    altezza: any;
    carte1: any;
    grammature1: any;
    colori1: any;
    fronte: any = "";
    plastificazioni1: any;
    tagli: any;
    lavorazioniAccessorie: any;
}

export class wizardFormStampaModel {
    numCopie: any;
    numSoggetti: any;
    formati: any;
    base: any;
    altezza: any;
    supportiRigidi: any;
    tagli: any;
    stampaBifacciale: any;
    biancoCoprente: any;
    lavorazioniAccessorie: any;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/document/quoting-submit-model.ts